import { Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { Button, Form, FormGroup, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Breadcrumb, LoginHeader} from "../../components";

function ServiceProviderContactUs() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider  /   Contact Us',
        },
    ];

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content providerDetailPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <div className="d-flex justify-content-between">
                                <Breadcrumb title="Service Provider Contact Us" breadcrumb={breadcrumb}/>
                                <Link to="/search-service-provider" className="btn btn-outline-info ms-3 mb-3 btn-sm">Back</Link>
                            </div>
                            <div className="detailsBox br-10 p-30 bg-white">
                                <Form>
                                    <FormGroup className="form-group">
                                        <label className="ant-label">Subject</label>
                                        <Input size="large" placeholder="Enter Subject" value="Urgent Requirement"  />
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                        <label className="ant-label">Message</label>
                                        <TextArea size="large" placeholder="Message"/>
                                    </FormGroup>
                                    <div className="d-flex justify-content-end mt-2 mt-xl-4">
                                        {/* <Link to="/search-service-provider" className="btn btn-light me-3 min-200">Cancel</Link> */}
                                        {/* <Button variant="primary" className="min-200">Submit</Button> */}
                                        <Link to="/my-bookings" className="btn btn-primary min-200">Submit</Link>
                                    </div>
                                </Form>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ServiceProviderContactUs;